/* eslint-disable no-unused-vars */
import io from 'socket.io-client';
import { patientCheckedInEventForTeleMedReceived, patientOnlineStatuesEventReceived } from '../workflow/workflow-slice';
import { CONNECT_SOCKET } from './constants';
import { socketUrl } from '../../api/env-variables';
import { notificationEvents } from './socketEvents';
import { patientCheckedInStatusHomeUpdate } from '../Home/home-slice';

let notificationChannel;

const establishConnection = () => {
  const notificationSocket = io.connect(`${socketUrl}/notification`, {
    query: {
      token: window.localStorage.getItem('__token__'),
    },
    secure: true,
  });
  return {
    notificationSocket,
  };
};

const emitEvent = (action, notification) => {
  const { payload } = action;
  const { channel, namespace } = action.socket;
  if (channel && namespace) {
    if (namespace === 'notification') {
      notification.emit(channel, payload);
    }
  }
};

const socketMiddleware = ({ dispatch }) => (next) => (action) => {
  if (action.type === CONNECT_SOCKET) {
    const { notificationSocket } = establishConnection();
    notificationChannel = notificationSocket;
    // register server side events
    notificationSocket?.on('patientOnlineStatuses', (payload) => {
      dispatch(patientOnlineStatuesEventReceived(payload));
    });

    notificationSocket?.on('checkedInNotification', (payload) => {
      dispatch(patientCheckedInEventForTeleMedReceived(payload));
      dispatch(patientCheckedInStatusHomeUpdate(payload));
    });
  }
  if (notificationChannel) {
    // socket actions
    if (action.socket) {
      emitEvent(action, notificationChannel);
    }
  }
  return next(action);
};

export default socketMiddleware;
